import { render, staticRenderFns } from "./ThemeSwitch.vue?vue&type=template&id=26f481b0&"
import script from "./ThemeSwitch.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ThemeSwitch.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports